const fonts = {
  body: "'Lato', sans-serif",
  heading: "'Lato', sans-serif",
  mono: "'Lato', sans-serif",
};

export default fonts;
